import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { CargueSegurosComponent } from './components/cargue-presupuesto/cargue-presupuesto.component';
import { CargueRoutingModule } from './cargue-routing.module';



@NgModule({
  declarations: [CargueSegurosComponent],
  imports: [
    CommonModule,
    ImportsModule,
    CargueRoutingModule,
  ],
  // providers: [DatePipe, UtilsService, GenerarPdfDetalleCuotasService, GenerarPdfHistorialPagosService]
})
export class CargueModule { }